import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Layout, Drawer, Affix } from "antd";
import Sidenav from "./SidenavSelector";
import Header from "./Header";


const { Header: AntHeader, Content, Sider } = Layout;

function Main({ children }) {
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState("right");
  const [sidenavColor, setSidenavColor] = useState("#ffd119");
  const [sidenavType, setSidenavType] = useState("transparent");
  const [fixed, setFixed] = useState(false);

  const openDrawer = () => setOpen((s) => !s);
  const handleSidenavType = (type) => setSidenavType(type);
  const handleSidenavColor = (color) => setSidenavColor(color);
  const handleFixedNavbar = (type) => setFixed(type);

  const location = useLocation();
  // keep raw pathname (with slashes) for correct segment parsing
  const rawPath = location.pathname || '';
  // shortPath without leading slash for other uses
  let pathname = rawPath.replace(/^\//, '');

  // Get custom page name or user object from location state if available
  const customPageName = location.state?.pageName || null;
  const locationUser = location.state?.user || null;

  // Derive a safe subName that won't leak raw IDs in the breadcrumb
  const deriveSafeSubName = (path) => {
    if (!path) return '';
    // split path into segments and filter empty
    const parts = path.split('/').filter(Boolean);
    if (parts.length === 0) return '';
    // Prefer explicit pageName or user name from location state when available
    if (customPageName) return customPageName;
    if (locationUser && (locationUser.name || locationUser.fullname)) return locationUser.name || locationUser.fullname;

    // mapping of route keys to French labels
    const routeLabels = {
      'user-reviews': 'Avis utilisateur',
      'reviews-list': 'Tous les avis',
      'Réclamations': 'Réclamations',
      'Reclamations': 'Réclamations',
      'Dashboard': 'Tableau de bord',
      'Paramétres': 'Paramètres',
      'Partenaires': 'Partenaires'
    };

    // If last segment looks like an id (uuid or long numeric) or contains an embedded uuid, normalize it
    const last = parts[parts.length - 1];
    const uuidRegexAnywhere = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}/;
    const longNumeric = /^\d{6,}$/;

    let candidate = last;
    // If the last part contains an embedded uuid (e.g., 'User-Reviewsf56d43...'), strip the uuid substring
    if (uuidRegexAnywhere.test(candidate)) {
      candidate = candidate.replace(uuidRegexAnywhere, '');
    }

    // If candidate now looks empty or is just punctuation, try previous segment
    if (!candidate || candidate.replace(/[^a-zA-Z0-9]/g, '').length === 0) {
      const prev = parts.length >= 2 ? parts[parts.length - 2] : '';
      if (prev) return routeLabels[prev] || prev.replace(/[-_]/g, ' ');
      return 'Détail utilisateur';
    }

    // If candidate itself is an id (long numeric), fallback to previous
    if (longNumeric.test(candidate)) {
      const prev = parts.length >= 2 ? parts[parts.length - 2] : '';
      if (prev) return routeLabels[prev] || prev.replace(/[-_]/g, ' ');
      return 'Détail utilisateur';
    }

    // Normalize candidate for mapping
    const normalizedKey = candidate.toString().toLowerCase().replace(/[^a-z0-9-]/g, '').replace(/^-+|-+$/g, '');
    if (routeLabels[normalizedKey]) return routeLabels[normalizedKey];

    // Otherwise return the full path cleaned (replace dashes)
    return parts.join(' ').replace(/[-_]/g, ' ');
  };
  const safeSubName = deriveSafeSubName(rawPath);

  useEffect(() => {
    if (pathname === "rtl") {
      setPlacement("left");
    } else {
      setPlacement("right");
    }
  }, [pathname]);

  return (
    <Layout
      className={`layout-dashboard ${
        pathname === "profile" ? "layout-profile" : ""
      } ${pathname === "rtl" ? "layout-dashboard-rtl" : ""}`}
    >
      <Drawer
        title={false}
        placement={placement === "right" ? "left" : "right"}
        closable={false}
  onClose={() => setOpen(false)}
  open={open}
        key={placement === "right" ? "left" : "right"}
        width={250}
        className={`drawer-sidebar ${
          pathname === "rtl" ? "drawer-sidebar-rtl" : ""
        } `}
      >
        <Layout
          className={`layout-dashboard ${
            pathname === "rtl" ? "layout-dashboard-rtl" : ""
          }`}
        >
          <Sider
            trigger={null}
            width={250}
            theme="light"
            className={`sider-primary ant-layout-sider-primary ${
              sidenavType === "#fff" ? "active-route" : ""
            }`}
            style={{ background: sidenavType }}
          >
            <Sidenav color={sidenavColor} />
          </Sider>
        </Layout>
      </Drawer>
      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        onCollapse={(collapsed, type) => {
          // Sidebar collapse handler
        }}
        trigger={null}
        width={250}
        theme="light"
        className={`sider-primary ant-layout-sider-primary ${
          sidenavType === "#fff" ? "active-route" : ""
        }`}
        style={{ background: sidenavType }}
      >
        <Sidenav color={sidenavColor} />
      </Sider>
      <Layout>
        {fixed ? (
          <Affix>
            <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`}>
              <Header
                onPress={openDrawer}
                name={pathname}
                subName={safeSubName || customPageName || pathname}
                handleSidenavColor={handleSidenavColor}
                handleSidenavType={handleSidenavType}
                handleFixedNavbar={handleFixedNavbar}
              />
            </AntHeader>
          </Affix>
        ) : (
          <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`}>
            <Header
              onPress={openDrawer}
              name={pathname}
              subName={safeSubName || customPageName || pathname}
              handleSidenavColor={handleSidenavColor}
              handleSidenavType={handleSidenavType}
              handleFixedNavbar={handleFixedNavbar}
            />
          </AntHeader>
        )}
        <Content className="content-ant">{children}</Content>
      
      </Layout>
    </Layout>
  );
}

export default Main;
